import React from "react";

const Icon = (props) => {
  switch (props.iconType) {
    case "Redux":
      return (
        <svg
          width="45"
          height="43"
          viewBox="0 0 256 244"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid"
        >
          <path
            d="M177.381 169.733c9.447-.978 16.614-9.122 16.288-18.896-.325-9.773-8.47-17.592-18.243-17.592h-.651c-10.1.326-17.918 8.796-17.592 18.895.326 4.887 2.28 9.122 5.212 12.054-11.076 21.828-28.016 37.791-53.426 51.148-17.266 9.122-35.183 12.38-53.1 10.1-14.66-1.955-26.062-8.47-33.23-19.222-10.424-15.963-11.401-33.23-2.605-50.496 6.19-12.38 15.962-21.502 22.152-26.063-1.303-4.235-3.258-11.402-4.235-16.614-47.237 34.207-42.35 80.468-28.016 102.295 10.75 16.29 32.577 26.389 56.684 26.389 6.515 0 13.03-.652 19.546-2.28 41.699-8.145 73.299-32.905 91.216-69.718zm57.336-40.397c-24.759-28.995-61.245-44.958-102.944-44.958h-5.212c-2.932-5.864-9.122-9.774-15.963-9.774h-.652C99.848 74.93 92.03 83.4 92.355 93.5c.326 9.773 8.47 17.592 18.243 17.592h.651c7.167-.326 13.357-4.887 15.963-11.077h5.864c24.759 0 48.214 7.167 69.39 21.176 16.288 10.751 28.016 24.76 34.531 41.7 5.538 13.683 5.212 27.04-.652 38.443-9.121 17.266-24.432 26.714-44.63 26.714-13.031 0-25.41-3.91-31.926-6.842-3.583 3.258-10.099 8.47-14.66 11.729 14.009 6.515 28.343 10.099 42.025 10.099 31.274 0 54.404-17.267 63.2-34.533 9.447-18.896 8.795-51.474-15.637-79.165zM69.225 175.27c.326 9.774 8.47 17.592 18.243 17.592h.652c10.099-.325 17.917-8.796 17.591-18.895-.325-9.774-8.47-17.592-18.243-17.592h-.651c-.652 0-1.63 0-2.28.325-13.357-22.153-18.895-46.26-16.94-72.323 1.302-19.547 7.818-36.488 19.22-50.497 9.447-12.054 27.69-17.918 40.07-18.243 34.531-.652 49.19 42.351 50.168 59.618 4.235.977 11.402 3.258 16.289 4.887C189.434 27.366 156.857 0 125.584 0c-29.32 0-56.359 21.176-67.11 52.451-14.985 41.7-5.212 81.771 13.031 113.372-1.628 2.28-2.606 5.864-2.28 9.448z"
            fill="#764ABC"
          />
        </svg>
      );
    case "Material":
      return (
        <svg
          width="46px"
          height="46px"
          viewBox="0 0 256 204"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          preserveAspectRatio="xMidYMid"
        >
          <g>
            <polygon
              fill="#00B0FF"
              points="0 110.848 0 0 96 55.424 96 92.3733333 32 55.424 32 129.322667"
            ></polygon>
            <polygon
              fill="#0081CB"
              points="96 55.424 192 0 192 110.848 128 147.797333 96 129.322667 160 92.3733333 160 55.424 96 92.3733333"
            ></polygon>
            <polygon
              fill="#00B0FF"
              points="96 129.322667 96 166.272 160 203.221333 160 166.272"
            ></polygon>
            <path
              d="M160,203.221333 L256,147.797333 L256,73.8986667 L224,92.3733333 L224,129.322667 L160,166.272 L160,203.221333 Z M224,55.424 L224,18.4746667 L256,5.68434189e-14 L256,36.9493333 L224,55.424 Z"
              fill="#0081CB"
            ></path>
          </g>
        </svg>
      );

    case "Tailwind":
      return (
        <svg
          width="50px"
          height="40px"
          viewBox="0 0 256 154"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          preserveAspectRatio="xMidYMid"
        >
          <defs>
            <linearGradient
              x1="-2.77777778%"
              y1="32%"
              x2="100%"
              y2="67.5555556%"
              id="linearGradient-1"
            >
              <stop stop-color="#2298BD" offset="0%"></stop>
              <stop stop-color="#0ED7B5" offset="100%"></stop>
            </linearGradient>
          </defs>
          <g>
            <path
              d="M128,-1.0658141e-14 C93.8666667,-1.0658141e-14 72.5333333,17.0666667 64,51.2 C76.8,34.1333333 91.7333333,27.7333333 108.8,32 C118.537481,34.4343704 125.497363,41.4985481 133.201067,49.3184 C145.750756,62.0567704 160.275437,76.8 192,76.8 C226.133333,76.8 247.466667,59.7333333 256,25.6 C243.2,42.6666667 228.266667,49.0666667 211.2,44.8 C201.462519,42.3656296 194.502637,35.3014519 186.798933,27.4816 C174.249244,14.7432296 159.724563,-1.0658141e-14 128,-1.0658141e-14 Z M64,76.8 C29.8666667,76.8 8.53333333,93.8666667 0,128 C12.8,110.933333 27.7333333,104.533333 44.8,108.8 C54.5374815,111.23437 61.497363,118.298548 69.2010667,126.1184 C81.7507556,138.85677 96.275437,153.6 128,153.6 C162.133333,153.6 183.466667,136.533333 192,102.4 C179.2,119.466667 164.266667,125.866667 147.2,121.6 C137.462519,119.16563 130.502637,112.101452 122.798933,104.2816 C110.249244,91.5432296 95.724563,76.8 64,76.8 Z"
              fill="url(#linearGradient-1)"
            ></path>
          </g>
        </svg>
      );

    case "React":
      return (
        <svg
          height="40"
          viewBox="175.7 78 490.6 436.9"
          width="54"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="#61dafb">
            <path d="m666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9v-22.3c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6v-22.3c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zm-101.4 106.7c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24s9.5 15.8 14.4 23.4zm73.9-208.1c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6s22.9-35.6 58.3-50.6c8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zm53.8 142.9c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6z" />
            <circle cx="420.9" cy="296.5" r="45.7" />
          </g>
        </svg>
      );

    case "HtmlCss":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          width="44px"
          height="44px"
        >
          <path
            fill="#7bbeeb"
            d="M5.015,7.244l5.466,45.246c0.194,1.603,1.337,2.935,2.9,3.379l17.535,4.977 c0.709,0.201,1.46,0.206,2.172,0.013l18.442-4.996c1.614-0.437,2.789-1.817,2.955-3.471l4.549-45.187C59.153,6.024,58.22,5,57.025,5 H7.019C5.809,5,4.87,6.051,5.015,7.244z"
          />
          <path
            fill="#ace3ff"
            d="M57.025,5H32v56c0.366,0.002,0.732-0.045,1.088-0.141l18.442-4.996 c1.614-0.437,2.789-1.817,2.955-3.471l4.549-45.187C59.153,6.024,58.22,5,57.025,5z"
          />
          <path
            fill="#8d6c9f"
            d="M32.025,62c-0.465,0-0.931-0.064-1.383-0.192l-17.535-4.977c-1.955-0.555-3.376-2.211-3.62-4.221 L4.021,7.364c-0.103-0.85,0.165-1.705,0.733-2.347C5.328,4.371,6.153,4,7.02,4h50.006c0.854,0,1.672,0.362,2.244,0.995 c0.567,0.628,0.845,1.47,0.76,2.311L55.48,52.493c-0.208,2.052-1.69,3.794-3.69,4.334l-18.44,4.996 C32.916,61.941,32.471,62,32.025,62z M7.02,6C6.721,6,6.448,6.122,6.252,6.344C6.06,6.561,5.973,6.838,6.008,7.124l0,0l5.466,45.246 c0.146,1.207,1.002,2.203,2.18,2.537l17.536,4.977c0.535,0.151,1.1,0.155,1.637,0.01l18.441-4.996 c1.205-0.326,2.099-1.373,2.223-2.605l4.549-45.188c0.028-0.283-0.062-0.556-0.253-0.769C57.59,6.119,57.319,6,57.025,6H7.02z"
          />
          <path
            fill="#8d6c9f"
            d="M7 12c-.553 0-1-.447-1-1V9c0-.553.447-1 1-1s1 .447 1 1v2C8 11.553 7.553 12 7 12zM12 12c-.553 0-1-.447-1-1V9c0-.553.447-1 1-1s1 .447 1 1v2C13 11.553 12.553 12 12 12zM17 12c-.553 0-1-.447-1-1V9c0-.553.447-1 1-1s1 .447 1 1v2C18 11.553 17.553 12 17 12zM22 12c-.553 0-1-.447-1-1V9c0-.553.447-1 1-1s1 .447 1 1v2C23 11.553 22.553 12 22 12zM27 12c-.553 0-1-.447-1-1V9c0-.553.447-1 1-1s1 .447 1 1v2C28 11.553 27.553 12 27 12zM32 12c-.553 0-1-.447-1-1V9c0-.553.447-1 1-1s1 .447 1 1v2C33 11.553 32.553 12 32 12zM37 12c-.553 0-1-.447-1-1V9c0-.553.447-1 1-1s1 .447 1 1v2C38 11.553 37.553 12 37 12zM42 12c-.553 0-1-.447-1-1V9c0-.553.447-1 1-1s1 .447 1 1v2C43 11.553 42.553 12 42 12zM47 12c-.553 0-1-.447-1-1V9c0-.553.447-1 1-1s1 .447 1 1v2C48 11.553 47.553 12 47 12zM52 12c-.553 0-1-.447-1-1V9c0-.553.447-1 1-1s1 .447 1 1v2C53 11.553 52.553 12 52 12zM57 12c-.553 0-1-.447-1-1V9c0-.553.447-1 1-1s1 .447 1 1v2C58 11.553 57.553 12 57 12zM39.999 54.806c-.44 0-.844-.293-.964-.738-.145-.533.17-1.082.703-1.227l2-.542c.534-.146 1.083.17 1.227.703.145.533-.17 1.082-.703 1.227l-2 .542C40.174 54.795 40.086 54.806 39.999 54.806zM32.024 57.003l-5.298-1.504c-.531-.15-.84-.704-.688-1.235.15-.531.701-.842 1.235-.688l4.763 1.352 3.702-1.002c.534-.148 1.083.17 1.227.703.145.533-.17 1.083-.703 1.227L32.024 57.003z"
          />
          <path
            fill="#fff8f8"
            d="M15.5 30l1.238 2.262L19 33.5l-2.262 1.238L15.5 37l-1.238-2.262L12 33.5l2.262-1.238L15.5 30zM47.502 47l.876 1.61L50 49.502l-1.622.876L47.502 52l-.892-1.622L45 49.502l1.61-.892L47.502 47zM52.504 23l.531.962L54 24.498l-.966.529L52.504 26l-.538-.973L51 24.498l.966-.536L52.504 23z"
          />
          <path
            fill="#faefde"
            d="M47.018,17H17c-0.614,0-1.083,0.548-0.987,1.155L16.776,23h24.598l-0.709,6H25v6h14.956l-0.901,7.625 l-6.961,2.122l-6.147-2.082l-0.444-2.821C25.426,39.358,25.007,39,24.515,39h-4.049c-0.614,0-1.083,0.549-0.988,1.156l1.014,6.439 c0.057,0.362,0.31,0.663,0.658,0.78l10.553,3.574C31.804,50.983,31.908,51,32.013,51c0.095,0,0.19-0.014,0.282-0.042l11.643-3.548 c0.374-0.114,0.646-0.439,0.691-0.827l2.891-24.465l0.475-4.019C48.064,17.514,47.607,17,47.018,17z"
          />
          <path
            fill="#8d6c9f"
            d="M32.014,52c-0.211,0-0.421-0.034-0.624-0.102l-10.56-3.576c-0.701-0.236-1.209-0.838-1.325-1.57 l-1.015-6.441c-0.091-0.578,0.075-1.165,0.455-1.61c0.381-0.445,0.935-0.7,1.521-0.7h4.05c0.991,0,1.822,0.711,1.976,1.69 l0.35,2.222l5.27,1.784l6.029-1.837L38.831,36H25c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1h14.776l0.473-4H16.775 c-0.492,0-0.911-0.358-0.988-0.845l-0.763-4.846c-0.091-0.577,0.075-1.164,0.455-1.609C15.86,16.255,16.414,16,17,16h30.019 c0.566,0,1.106,0.243,1.483,0.666c0.375,0.423,0.553,0.988,0.486,1.551l-3.365,28.482c-0.093,0.782-0.639,1.437-1.393,1.666 l-11.643,3.55C32.402,51.972,32.209,52,32.014,52z M20.466,40l1.015,6.439l10.543,3.563l11.623-3.55L47,18H17l0.63,4h23.744 c0.286,0,0.558,0.122,0.747,0.336c0.19,0.213,0.279,0.498,0.246,0.781l-0.709,6C41.599,29.621,41.172,30,40.665,30H26v4h13.956 c0.285,0,0.558,0.122,0.747,0.336c0.19,0.213,0.279,0.498,0.246,0.781l-0.9,7.625c-0.047,0.395-0.322,0.724-0.701,0.839 l-6.961,2.122c-0.201,0.062-0.415,0.059-0.612-0.009l-6.147-2.082c-0.353-0.119-0.609-0.424-0.668-0.792L24.515,40H20.466z"
          />
        </svg>
      );

    case "JavaScript":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="40"
          viewBox="0 0 1052 1052"
        >
          <path fill="#f0db4f" d="M0 0h1052v1052H0z" />
          <path
            d="M965.9 801.1c-7.7-48-39-88.3-131.7-125.9-32.2-14.8-68.1-25.399-78.8-49.8-3.8-14.2-4.3-22.2-1.9-30.8 6.9-27.9 40.2-36.6 66.6-28.6 17 5.7 33.1 18.801 42.8 39.7 45.4-29.399 45.3-29.2 77-49.399-11.6-18-17.8-26.301-25.4-34-27.3-30.5-64.5-46.2-124-45-10.3 1.3-20.699 2.699-31 4-29.699 7.5-58 23.1-74.6 44-49.8 56.5-35.6 155.399 25 196.1 59.7 44.8 147.4 55 158.6 96.9 10.9 51.3-37.699 67.899-86 62-35.6-7.4-55.399-25.5-76.8-58.4-39.399 22.8-39.399 22.8-79.899 46.1 9.6 21 19.699 30.5 35.8 48.7 76.2 77.3 266.899 73.5 301.1-43.5 1.399-4.001 10.6-30.801 3.199-72.101zm-394-317.6h-98.4c0 85-.399 169.4-.399 254.4 0 54.1 2.8 103.7-6 118.9-14.4 29.899-51.7 26.2-68.7 20.399-17.3-8.5-26.1-20.6-36.3-37.699-2.8-4.9-4.9-8.7-5.601-9-26.699 16.3-53.3 32.699-80 49 13.301 27.3 32.9 51 58 66.399 37.5 22.5 87.9 29.4 140.601 17.3 34.3-10 63.899-30.699 79.399-62.199 22.4-41.3 17.6-91.3 17.4-146.6.5-90.2 0-180.4 0-270.9z"
            fill="#323330"
          />
        </svg>
      );
    case "Git":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="44"
          height="44"
          viewBox="0 0 32 32"
        >
          <path
            d="M31.396 14.575L17.425.604a2.06 2.06 0 0 0-2.914 0l-2.9 2.9 3.68 3.68c.856-.3 1.836-.095 2.518.587a2.45 2.45 0 0 1 .581 2.533l3.547 3.547c.858-.296 1.848-.105 2.533.582a2.45 2.45 0 1 1-3.469 3.468c-.72-.72-.898-1.78-.534-2.667l-3.308-3.308v8.705a2.5 2.5 0 0 1 .65.464 2.45 2.45 0 1 1-3.468 3.468 2.45 2.45 0 0 1 0-3.468c.237-.236.5-.415.803-.535v-8.786c-.292-.12-.566-.297-.803-.535a2.45 2.45 0 0 1-.528-2.681l-3.63-3.628-9.58 9.57a2.06 2.06 0 0 0 0 2.915l13.972 13.97a2.06 2.06 0 0 0 2.914 0L31.396 17.5a2.06 2.06 0 0 0 0-2.915"
            fill="#f03c2e"
          />
        </svg>
      );
    case "Azure":
      return (
        <svg
          width="46px"
          height="39px"
          viewBox="0 0 256 169"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          preserveAspectRatio="xMidYMid"
        >
          <g>
            <path
              d="M152.000362,95.1993124 C145.600347,95.1993124 140.000029,99.1990171 136.800021,104.799335 L42.3997962,104.799335 C26.3997581,104.799335 13.5997276,91.1996076 13.5997276,75.1995695 C13.5997276,59.1995314 26.3997581,45.5998038 42.3997962,45.5998038 L55.9995238,45.5998038 C55.9995238,42.3997962 57.5995276,39.1997886 58.3998343,35.999781 C59.1995314,35.2000838 59.1995314,33.5994705 59.9998381,32.7997733 C66.3998533,20.79944 79.1998838,12.8000305 93.5999181,12.8000305 C106.399949,12.8000305 117.599975,19.2000457 124.800297,28.8000686 C128.800002,27.2000648 132.800316,25.600061 137.600328,24.8003638 C128.800002,9.60002286 112.799964,0 93.5999181,0 C71.9995619,0 53.5998229,13.6003371 45.5998038,32.8003829 L42.3997962,32.8003829 C19.2000457,32.7991638 0,51.9992095 0,75.9992667 C0,99.9993238 19.2000457,118.399063 42.3997962,118.399063 L137.600328,118.399063 C140.000638,123.999381 145.600347,127.999086 152.800669,127.999086 C161.600994,127.999086 168.800707,120.799373 168.800707,111.19935 C168.800707,101.599328 161.600385,95.1993124 152.000362,95.1993124 Z M204.800488,62.3989295 C195.200465,43.1988838 175.200722,29.5991562 152.800669,29.5991562 C124.800297,29.5991562 101.600547,49.598899 96.0002286,75.9992667 C82.400501,77.5992705 70.4001676,84.7989829 63.2004552,95.1993124 L132.800926,95.1993124 C137.600937,88.7992971 144.801259,85.5992895 152.800669,85.5992895 C167.200703,85.5992895 178.40073,97.5996229 178.40073,111.999048 C178.40073,126.398472 166.400396,138.398806 152.800669,138.398806 C144.80065,138.398806 137.600328,134.399101 132.800926,128.798783 L55.1998267,128.798783 C58.3998343,151.198836 77.59988,168.798878 99.9999333,168.798878 L204.000181,168.798878 C232.80025,168.798878 256,145.599128 256,115.998752 C256,86.3983771 232.800859,63.1992362 204.800488,62.3989295 Z"
              fill="#008CDB"
            ></path>
          </g>
        </svg>
      );
    case "D3":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="44"
          height="34"
          viewBox="0 0 32 32"
          preserveAspectRatio="xMidYMid"
        >
          <defs>
            <linearGradient
              x1="105.124"
              y1="18.816"
              x2="258.888"
              y2="180.747"
              id="A"
              xlinkHref="#G"
            >
              <stop stop-color="#f9a03c" offset="0%" />
              <stop stop-color="#f7974e" offset="100%" />
            </linearGradient>
            <linearGradient
              x1="-21.438"
              y1="48.347"
              x2="121.931"
              y2="188.876"
              id="B"
              xlinkHref="#G"
            >
              <stop stop-color="#f9a03c" offset="0%" />
              <stop stop-color="#f7974e" offset="100%" />
            </linearGradient>
            <linearGradient
              x1="44.776"
              y1="97.471"
              x2="174.952"
              y2="242.691"
              id="C"
              xlinkHref="#G"
            >
              <stop stop-color="#f9a03c" offset="0%" />
              <stop stop-color="#f7974e" offset="100%" />
            </linearGradient>
            <linearGradient
              x1="29.009"
              y1="-4.41"
              x2="211.054"
              y2="222.914"
              id="D"
              xlinkHref="#G"
            >
              <stop stop-color="#f26d58" offset="0%" />
              <stop stop-color="#f9a03c" offset="100%" />
            </linearGradient>
            <linearGradient
              x1="120.653"
              y1="6.744"
              x2="288.266"
              y2="126.53"
              id="E"
              xlinkHref="#G"
            >
              <stop stop-color="#b84e51" offset="0%" />
              <stop stop-color="#f68e48" offset="100%" />
            </linearGradient>
            <linearGradient
              x1="83.051"
              y1="171.518"
              x2="91.707"
              y2="286.309"
              id="F"
              xlinkHref="#G"
            >
              <stop stop-color="#f9a03c" offset="0%" />
              <stop stop-color="#f7974e" offset="100%" />
            </linearGradient>
            <linearGradient id="G" gradientUnits="userSpaceOnUse" />
          </defs>
          <g transform="matrix(.125041 0 0 .125041 0 .844399)">
            <path
              d="M255.52 175.62l.26-3.37c.078-1.34-80.562-77.85-80.562-77.85H173.3s81.736 86.215 82.23 81.22z"
              fill="url(#A)"
            />
            <path
              d="M83.472 149.077l-.323.704-.35.734c-2.57 5.36 35.987 43.053 39.088 38.474l.424-.618.467-.7c2.48-3.765-38.206-41.032-39.307-38.584z"
              fill="url(#B)"
            />
            <path
              d="M137.957 202.083c-.1.24-.885 1.552-1.594 2.245-.12.24 37.64 37.688 37.64 37.688h3.4c.002 0-35.446-38.35-39.446-39.933z"
              fill="url(#C)"
            />
            <path
              d="M255.835 171.568c-1.766 39.147-34.152 70.448-73.72 70.448h-5.35l-39.514-38.928c3.25-4.584 6.272-9.333 8.962-14.285h35.902c11.354 0 20.594-9.235 20.594-20.595 0-11.355-9.24-20.595-20.594-20.595H160.87c1.62-8.557 2.504-17.38 2.504-26.408 0-9.165-.9-18.114-2.578-26.808h13.197l81.6 80.414a91.25 91.25 0 0 0 .233-3.243zM21.467 0H0v53.213h21.467c37.493 0 68 30.5 68 67.992a67.6 67.6 0 0 1-6.318 28.576l39.163 38.6a120.48 120.48 0 0 0 20.376-67.166C142.688 54.373 88.307 0 21.467 0z"
              fill="url(#D)"
            />
            <path
              d="M182.115 0H95.187C116.42 12.963 134 31.344 145.98 53.213h36.136c11.354 0 20.594 9.235 20.594 20.595S193.47 94.4 182.115 94.4h-8.12l81.6 80.413c.192-2.18.312-4.376.312-6.605 0-17.94-6.437-34.395-17.125-47.203 10.688-12.802 17.125-29.26 17.125-47.197C255.917 33.112 222.813 0 182.115 0z"
              fill="url(#E)"
            />
            <path
              d="M176.765 242.016H95.808c16.296-10.064 30.384-23.35 41.443-38.928zm-54.453-53.645l-39.16-38.6c-10.82 23.25-34.395 39.422-61.685 39.422H0V242.4h21.467c42 0 79.1-21.488 100.845-54.04z"
              fill="url(#F)"
            />
          </g>
        </svg>
      );
       
    default:
      return null;
  }
};

export default Icon;
